<template>
  <reason-list :level="1" />
</template>

<script>
import ReasonList from "./components/ReasonList.vue";

export default {
  name: "ClaimAccidentReasons",
  components: { ReasonList }
};
</script>
